import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Toast from './toast';
import Features from './utils/features';
import money from 'v-money';

const CURRENCY = new Intl.NumberFormat([], {
  style: 'currency',
  currency: 'BRL'
});

// mask
import VueMask from 'v-mask';
Vue.use(VueMask);

import moment from 'moment';
moment.locale('pt-BR');

Vue.prototype.$toast = Toast;
Vue.prototype.$moment = moment;
Vue.prototype.$allows = Features.allows;
Vue.prototype.$can = function(register) {
  const user = this.$store.state.user.user;
  if (user.rule === 'admin' || user.rule === 'partner') return true;
  return Array.isArray(user.permissions) && user.permissions.includes(register);
};
Vue.prototype.$sleep = ms => new Promise(res => setTimeout(res, ms));
Vue.prototype.$scrollTop = () => {
  $('.page').stop().animate({ scrollTop: 0 }, 500);
};
Vue.prototype.$raw = value =>
  value == null ? null : value.replace(/[^\w\s]/gi, '');
Vue.config.productionTip = false;

window.$ = window.jQuery = window.jquery = require('jquery');
window._ = require('lodash');

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
});

// autocomplete-off
Vue.directive('autocomplete-off', {
  bind: function (el) {
    const inputs = $(el)
      .find(
        "input[type='text'], input[type='password'], input[type='email'], select, textarea"
      )
      .toArray();
    inputs.forEach(input => {
      $(input).attr('autocomplete', 'off');
    });
  }
});

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    el.focus();
  }
});

Vue.directive('go-back', {
  bind: function (el, binding) {
    const previousPath = store.state.nav.previous;
    let path = `/${binding.value}`;

    if (path == previousPath || previousPath.includes(`${path}?`)) {
      path = previousPath;
    }

    el.setAttribute('href', path);
  }
});

Vue.filter('date', function (value) {
  if (!value) return '';
  return moment(value).format('DD/MM/YYYY');
});

Vue.filter('datetime', function (value) {
  if (!value) return '';
  return moment(value).format('DD/MM/YYYY HH:mm');
});

Vue.filter('money', function (value) {
  if (!value) return '';
  return CURRENCY.format(value);
});

Vue.filter('sequence', function (value) {
  if (!value) return '';
  return `${value} º`;
});

// semantic
require('semantic-ui-css/semantic.css');
require('semantic-ui-css/semantic.js');

require('cropperjs/dist/cropper.css');

import './assets/css/animations.css';
import './assets/css/variables.css';
import './assets/css/common.css';
import './assets/css/page.css';
import './assets/css/semantic_override.css';

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
